
import { defineComponent, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Anchor from '@/elements/anchor/Anchor.vue';
import Footer from '@/components/footer/Footer.vue';
import Header from '@/components/header/Header.vue';
import Logo from '@/assets/Logo.vue';
import Nav from '@/components/nav/Nav.vue';
import NavItem from '@/components/nav/NavItem.vue';

export default defineComponent({
  setup() {
    const { t, locale } = useI18n();

    const menuOpen = ref(false);

    return { t, locale, menuOpen };
  },
  components: {
    Anchor,
    Footer,
    Header,
    Logo,
    Nav,
    NavItem,
  },
});
